import { setIncludes } from "./setIncludes";

const outcomesInclude = (
  allowed: Set<string>,
  values: (string | undefined)[],
  includeAll = false,
) => {
  // an outcome with no value fails all-must-match
  if (includeAll && values.includes(undefined)) return false;

  return setIncludes(
    allowed,
    new Set(values.filter((value): value is string => value !== undefined)),
    includeAll,
  );
};

export { outcomesInclude };
